import React from 'react';
import { colors } from '@keen.io/colors';
import { Line } from '../elements';
var HoverLine = function (_a) {
    var x1 = _a.x1, x2 = _a.x2, y1 = _a.y1, y2 = _a.y2;
    return (React.createElement("g", { color: colors.blue[500], pointerEvents: "none" },
        React.createElement(Line, { x1: x1, x2: x2, y1: y1, y2: y2 }),
        React.createElement("circle", { cx: x1, cy: y1, r: "3", fill: "currentColor" }),
        React.createElement("circle", { cx: x1, cy: y1, r: "2", fill: "white" }),
        React.createElement("circle", { cx: x2, cy: y2, r: "3", fill: "currentColor" }),
        React.createElement("circle", { cx: x2, cy: y2, r: "2", fill: "white" })));
};
export default HoverLine;
